export default "__VITE_ASSET__Befhe$S___"